import { render, staticRenderFns } from "./freezer-device-info.vue?vue&type=template&id=14effa12&scoped=true&"
import script from "./freezer-device-info.vue?vue&type=script&lang=js&"
export * from "./freezer-device-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14effa12",
  null
  
)

export default component.exports